import { useState, useEffect } from "react";
import NavigationBar from "../components/navBar";
import Footer from "../components/footer";
import ContentRenderer from "../components/ContentRenderer";
import HeroSection from "../components/HeroSection";
import { faqs } from "../data/faqs";
import { useLocation } from "react-router-dom";

export default function FaQs() {
  const [openIndex, setOpenIndex] = useState(null);
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  const toggleFaq = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <div id="overhaul-v2-root">
      <title>FAQs</title>
      <NavigationBar />

      <HeroSection
        title="FAQ"
        theme="aboutus"
        previousPath={location.state?.from}
      />

      <main className="max-w-4xl mx-auto px-6 py-16 min-h-[50vh]">
        <h2 className="text-3xl font-bold text-center mb-12 font-sans text-gray-800">
          Solution Challenge FAQs
        </h2>

        <div className="space-y-4">
          {faqs.map((faq, i) => {
            const open = openIndex === i;

            return (
              <div
                key={i}
                className="border border-gray-200 rounded-xl bg-white shadow-md overflow-hidden"
              >
                <button
                  onClick={() => toggleFaq(i)}
                  className="w-full flex justify-between items-center p-5 text-left text-lg hover:bg-gray-50 transition-colors font-bold font-sans tracking-wide text-gray-800"
                >
                  <span>{faq.question}</span>
                  <span
                    className={`transform transition-transform duration-300 text-gray-500 ${open ? "rotate-180" : "rotate-0"
                      }`}
                  >
                    ⌄
                  </span>
                </button>

                <div
                  style={{
                    maxHeight: open ? "1000px" : "0px",
                    opacity: open ? 1 : 0,
                    transform: open ? "translateY(0)" : "translateY(-10px)",
                  }}
                  className="transition-all duration-500 ease-in-out overflow-hidden px-5"
                >
                  <div className="py-5">
                    <ContentRenderer blocks={faq.content} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </main>

      <Footer />
    </div>
  );
}
